import { trackApplicationEvent } from 'tracking/application/trackApplicationEvent';

export const trackOpenedWidget = trackApplicationEvent('OPENED_APPLICATION_WIDGET');
export const trackClosedWidget = trackApplicationEvent('CLOSED_APPLICATION_WIDGET');
